<ng-template #content>
    <div class="w-full h-full flex flex-col">
        <div class="mb-2">
            <p class="text-sm text-light my-0.5">{{ 'Info_AssignQuestionsToGroup' | translate }}</p>
            <div class="input-button-group flex">
                <kendo-multiselect #multiSelectInput
                                   class="bizz-combobox-multiselect"
                                   [data]="filteredOptions"
                                   textField="Text"
                                   valueField="Value"
                                   [(ngModel)]="selected"
                                   (valueChange)="onValueChanged($event)"
                                   [disabled]="copyFromCategory"
                                   [valuePrimitive]="false"
                                   [filterable]="true"
                                   [clearButton]="false"
                                   [allowCustom]="true"
                                   (filterChange)="filter($event)">
                    <ng-template kendoMultiSelectTagTemplate let-dataItem>
                        <span class="text-xs">{{ dataItem.Text }}</span>
                    </ng-template>
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span class="text-nowrap py-0.5 text-xs text-default">
                                    {{ dataItem.Text }}
                            </span>
                    </ng-template>
                </kendo-multiselect>
                <div class="button-group">
                    <button type="button"
                            [disabled]="copyFromCategory"
                            class="default !px-2 !py-1"
                            (click)="multiSelectInput.toggle()">
                        <bizz-toggle-arrow class="pointer-events-none size-4"
                                           [direction]="multiSelectInput.isOpen ? 'up' : 'down'">
                        </bizz-toggle-arrow>
                    </button>
                </div>
            </div>
        </div>

        @if (canCopyFromCategory) {
            <div class="mb-2 flex items-center gap-2" (click)="copyFromCategory = !copyFromCategory">
                <input type="checkbox" [(ngModel)]="copyFromCategory"/>
                <label class="text-sm text-light my-0.5">{{ 'CopyFromCategory' | translate }}</label>
            </div>
        }
    </div>
</ng-template>
<ng-template #footer>
    <div class="modal-buttons">
        <button class="default" (click)="dialogRef.close()">
            {{ 'Cancel' | translate }}
        </button>
        <button class="save min-w-16" (click)="save()">
            {{ 'Save' | translate }}
        </button>
    </div>
</ng-template>
<bizz-modal [title]="'AssignGroup' | translate "
            [message]="'Info_AssignGroup' | translate"
            modalSize="xs"
            [contentTemplate]="content"
            [footerTemplate]="footer"></bizz-modal>
